var $c32f8c2b8956f20a$exports = {};
$c32f8c2b8956f20a$exports = {
    "dismiss": `Ner\u{101}d\u{12B}t`
};


export {$c32f8c2b8956f20a$exports as default};
//# sourceMappingURL=lv-LV.mjs.map
